<div class="content-center">
  <app-dataset-information
    [form]="form"
    mode="full"
    [overlayDisabled]="isColumnSettingsOpen">
  </app-dataset-information>

  <div class="dataset-overlay-zone" #datasetOverlayZone>
    <!-- Added by Amisha on 04/24/2026: guard filter fields while a published dataset is loading from navigation state so the page does not crash before ds is ready. -->
    <app-dataset-filter-input-config [form]="filterInputForm" [allowFiltering]="allowFiltering"
      [filterFields]="ds?.filterConfig?.fields || []" [columnOptions]="columnOptions"
      (allowFilteringChanged)="allowFilteringChanged($event)" (saveFilterInput)="onSaveFilterInput($event)"
      (filterSaved)="saveFilter($event)" (deleteFilterInput)="deleteFilter($event)" ></app-dataset-filter-input-config>

    <!-- added by ketan 09-03-2026 -->
    <ng-template [ngTemplateOutlet]="sortingConfigurationCardTemplate"></ng-template>
    <!-- ended by ketan 09-03-2026 -->
    <wm-dataset-add-workflows
      #datasetAddWorkflows
      [dataSetConfig]="dataSet"
      [availableWorkflows]="availbleWorkflows"
      (datasetChange)="onDatasetChange($event)"
      (openColumnSettingsRequested)="openColumnSettingsModal($event)"
      (workflowSelected)="onWorkflowSelected($event)">
      
    </wm-dataset-add-workflows>
    
    <!-- [columnOptions]="dataSet.fields" -->
  
    <div class="dataset-btns">
      <div class="test-save-btn">
        <wm-common-button [data]="{
            text: 'TEST DATA SET',
            onClick: testDataSet.bind(this),
            disabled: !canTest()
          }"></wm-common-button>
      </div>
      <div class="test-save-btn">
        <wm-common-button [data]="{
            text: 'SAVE DATA SET',
            onClick: saveDataSet.bind(this)
          }"></wm-common-button>
      </div>
      <div class="publish-btn">
        <wm-common-button [data]="{
            text: 'PUBLISH DATA SET',
            onClick: onOpenPublishData.bind(this),
            disabled: !canPublish
          }"></wm-common-button>
           <wm-common-confirmation-modal
           #publishModal
           [data]="publishDataSetModalData"
           (onNoClick)="onClosePublishData()"
           (onYesClick)="publishDataSet()"
         ></wm-common-confirmation-modal>
      </div>
    </div>

    <app-loader *ngIf="executingTest"></app-loader>

    <div class="card" *ngIf="resultColumns && resultRows">
      <div class="test-results-header">
        <div class="test-results-title">
          <wm-common-text [data]="{ text: 'Test Data Set Results' }"></wm-common-text>
        </div>
        <button
          type="button"
          class="test-results-close-btn"
          aria-label="Close test results"
          (click)="closeTestResults()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="card-body">
        <wm-common-table
          tableType="Staff"
          [columns]="resultColumns"
          [data]="resultRows"
          [defaultPageSize]="10"
          [showRowsPerPage]="true"
        ></wm-common-table>
      </div>
    </div>

    <div class="card" *ngFor="let aggResultKey of aggResultKeys">
      <div class="card-body" *ngIf="aggregatedResultColumns?.[aggResultKey] && aggregatedResultRows?.[aggResultKey]">
        <div class="card-title">
          <h4>{{ aggResultKey }}</h4>
        </div>
        <wm-common-table
          tableType="Staff"
          [columns]="aggregatedResultColumns[aggResultKey]"
          [data]="aggregatedResultRows[aggResultKey]"
          [defaultPageSize]="10"
          [showRowsPerPage]="true"
        ></wm-common-table>
      </div>
    </div>

    <wm-column-settings
      *ngIf="isColumnSettingsOpen"
      [workflowId]="selectedColumnSettingsWorkflowId"
      [field]="selectedColumnSettingsField"
      [containedOverlay]="true"
      [overlayTopOffsetPx]="columnSettingsTopOffsetPx"
      (saveColumn)="handleColumnSettingsSave($event)"
      (closePanel)="closeColumnSettingsModal()">
    </wm-column-settings>
  </div>
</div>

<!-- <modal-confirm
  #filterInputConfig
  title="Filter Input Column Settings">

  <app-dataset-filter-input-dialog
    [field]="filterInputField">
  </app-dataset-filter-input-dialog>

</modal-confirm> -->

<!-- added by ketan 09-03-2026 -->
<ng-template #sortingConfigurationCardTemplate>
  @if (showSortingConfiguration) {
  <div>
    <div class="card">
      <div class="card-body">
        <div class="card-title">
          <h4>Sorting Configuration</h4>
        </div>
        <!-- Added by amisha on 05/04/2026 so sorting controls can scroll inside their own container
             on smaller screens instead of pushing the full dataset editor width. -->
        <div class="row sorting-table-wrapper">
          <table class="sorting-config-table">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <!-- Added by Amisha on 04/24/2026: wait for dataset sorting state before rendering the sorting rows to avoid undefined fieldOrder errors during redirect-based prefill. -->
            @if (form.controls['fieldOrder'] && dataSet?.fieldOrder && dataSet?.fields) {

            <tbody dragula="sortFields" [(dragulaModel)]="dataSet.fieldOrder" (dragulaModelChange)="orderChange()">

              @for (fo of dataSet.fieldOrder; track $index; let idx = $index) {

              <tr>

                <!-- Drag Icon -->
                <td class="drag-icon">

                  @if (dataSet.fieldOrder.length > 1) {
                  <mat-icon style="cursor: grab" matTooltip="Order the sorting priority">
                    drag_indicator
                  </mat-icon>
                  }

                </td>

                <!-- Order By -->
                <td>
                  <div class="dropdown-label-text" [class.required-placeholder]="!fo.fieldName" [matMenuTriggerFor]="orderByMenu">
                    <wm-common-text [data]="{ text: getFieldLabel(fo.fieldName) || 'ORDER BY' }">>
                    </wm-common-text>
                    <wm-common-icon [data]="{iconName:keyBoardDropDownIcon}">
                    </wm-common-icon>
                  </div>
                  <!-- Added by Amisha on 09/25/2026. Reason: scope the Order By
                       panel width and allow the component to close it on scroll. -->
                  <mat-menu #orderByMenu="matMenu" class="sorting-config-menu">
                    <!-- Added by amisha on 05/04/2026 to move the menu width into CSS so
                         desktop and responsive breakpoints can share the same dropdown shell. -->
                    <div class="sorting-menu-panel">
                      @if (dataSet.fields.length == 0) {
                      <button mat-menu-item disabled>
                        (Add Column to Data Set)
                      </button>
                      }
                      @for (f of dataSet.fields; track f.name) {
                      <button mat-menu-item (click)="selectOrderBy(f.name, idx)">
                        {{ f.name }}
                      </button>
                      }
                    </div>
                  </mat-menu>
                  <wm-control-message
                    [control]="form.controls['fieldOrder'].controls['field' + idx]"></wm-control-message>
                </td>
                <!-- Direction -->
                <td>
                  <div class="dropdown-label-text" [class.required-placeholder]="!form.controls['fieldOrder'].controls['order' + idx].value" [matMenuTriggerFor]="directionMenu">
                    <wm-common-text
                      [data]="{ text: form.controls['fieldOrder'].controls['order' + idx].value === 1 ? 'Ascending' : form.controls['fieldOrder'].controls['order' + idx].value === 2 ? 'Descending' : 'DIRECTION' }">
                    </wm-common-text>
                    <wm-common-icon [data]="{iconName:keyBoardDropDownIcon}">
                    </wm-common-icon>
                  </div>
                  <!-- Added by Amisha on 09/25/2026. Reason: scope the Direction
                       panel width and allow the component to close it on scroll. -->
                  <mat-menu #directionMenu="matMenu" class="sorting-config-menu">
                    <!-- Added by amisha on 05/04/2026 to keep direction-menu sizing aligned
                         with the order-by menu across desktop, tablet, and mobile. -->
                    <div class="sorting-menu-panel">
                      <button mat-menu-item (click)="selectDirection(1, idx)">
                        Ascending
                      </button>
                      <button mat-menu-item (click)="selectDirection(2, idx)">
                        Descending
                      </button>
                    </div>
                  </mat-menu>
                  <wm-control-message [control]="form.controls['fieldOrder'].controls['order' + idx]">
                  </wm-control-message>
                </td>
                <!-- Delete -->
                <td>
                  @if (idx != 0) {
                  <ng-template #deleteSortingConfigurationIconTemplate>
                    <div class="delete-sorting-configuration-icon">
                      <wm-common-icon [data]="{iconName:'delete'}"></wm-common-icon>
                    </div>
                  </ng-template>
                  <wm-common-button
                    [data]="onSortingConfigurationDeleteClick(deleteSortingConfigurationIconTemplate,fo)"></wm-common-button>
                  }
                </td>
              </tr>
              }
            </tbody>
            }
          </table>
        </div>
        <!-- add button -->
        <div class="add-sorting-column-container" (click)="addSortOrder()">
          <wm-common-text [data]="{text:'+ Add Sorting Column'}"></wm-common-text>
        </div>
      </div>
    </div>
  </div>
  }
  <wm-common-confirmation-modal [data]="sortingConfigurationDeleteModalData"
    (onYesClick)="handleSortingConfigurationDeleteModalAccepted(sortingConfigurationDeleteTarget!)"
    (onNoClick)="handleSortingConfigurationDeleteModalRejected()">
  </wm-common-confirmation-modal>
</ng-template>
<!-- ended by ketan 09-03-2026 -->

<wm-common-confirmation-modal
  [data]="saveSuccessModalData"
  (onOkClick)="handleSaveSuccessModalOk()">
</wm-common-confirmation-modal>
